<template>
  <b-card class="mb-4 border-0 font_avenir card_orderslist">
    <b-spinner v-if="loadingPage"></b-spinner>
    <div class="holder_table">
      <table class="table">
        <thead>
          <tr>
            <th id='exc_th_id' scope="col" class="hidden">ID</th>
            <th id='exc_th_id' scope="col" style="width: 8%">Created at</th>
            <th id='exc_th_name' scope="col" style="width: 6%">Order ID</th>
            <th id='exc_th_type' scope="col" style="width: 8%" v-if="tagModule === 'PATIENT_SEARCH'">Type</th>
            <th id='exc_th_descriptions' scope="col" style="width:12%">Component Type</th>
            <th id='exc_th_sku' scope="col" style="width: 12%" v-if="tagModule != 'PATIENT_SEARCH'">Patient ID</th>
            <th id='exc_th_clients' scope="col" style="width: 10%">SKU</th>
            <th id='exc_th_descriptions' scope="col" style="width:12%">Client Name</th>
            <th id='exc_th_descriptions' scope="col" style="width: 11%">Method</th>
            <th id='exc_th_descriptions' scope="col" style="width: 13%">Ship Via</th>
            <th id='exc_th_descriptions' scope="col" style="width: 12%">Status</th>
            <th id='exc_th_options' scope="col" class="hidden" v-if="tagModule != 'PATIENT_SEARCH'">... options</th>
            <th id='exc_th_actions' class="text-center" scope="col" style="width: 11%">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orders" :key="order.order_id">
            <td class="hidden" scope="row">{{ order.client_name }}</td>
            <td style="width: 14%">{{ order.created_at }}</td>
            <td style="width: 8%" >
              <b-link :to="`/orders/${order.order_id}`">
                 {{ order.order_id }}
              </b-link>
            </td>
            <td style="width: 8%" class="td_type" v-if="tagModule === 'PATIENT_SEARCH'">{{ translations.type[order.type] || order.type }}</td>
            <td style="width: 12%">{{ translations.component_type[order.component_type] || order.component_type }}</td>
            <td style="width: 12%" v-if="tagModule != 'PATIENT_SEARCH'" class="td_patient_id">{{ order.patient_id }}</td>
            <td style="width: 10%">{{ order.sku }}</td>
            <td style="width: 12%">{{ order.client_name }}</td>
            <td style="width: 11%">{{ order.method }}</td>
            <td style="width: 13%">{{ order.ship_via }}</td>
            <td style="width: 12%" class="div_clex_name orders-colors">
            <span :class="[order.status, 'clex_name']">{{ translations.status[order.status] || order.status }}</span>
            </td>
            <td class="hidden td_options" v-if="tagModule != 'PATIENT_SEARCH'"></td>
            <td style="width: 11%" class="align-middle text-center">
              <div class="btn-group dropleft">
                <button
                  variant="light"
                  type="button"
                  class="btn btn-light"
                  data-toggle="dropdown"
                  aria-expanded="false">
                  <feather type="more-horizontal"></feather>
                </button>
                <div class="dropdown-menu">
                  <orderAllowedActions
                    :order="order">
                  </orderAllowedActions>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row pt-2">
      <div class="col-12 d-flex justify-content-center">
        <b-pagination :disabled="loadingPage"
                      @change="changePage"
                      v-model="currentPage"
                      :total-rows="total"
                      :per-page="itemsPerPage"
                      size="md">
        </b-pagination>
      </div>
    </div>
  </b-card>
</template>

<script>
import axios from 'axios';
import integer from 'vuelidate/lib/validators/integer';
import translations from '@/translations';
import orderHandler from '@/mixins/orderHandler';
import {
  ORDER_TYPE, QUERY_OPERATORS, ORDER_TAGS, QUERY_FIELD, CLIENT_MODE,
} from '@/scripts/constants';
import orderAllowedActions from './OrderAllowedActions.vue';

export default {
  name: 'orders-list',
  components: {
    orderAllowedActions,
  },
  props: {
    tagModule: {
      type: String,
      default: null,
    },
    tagId: {
      type: integer,
      default: null,
    },
    filters: {
      type: Object,
      default: () => ({
        isValid: false,
        data: {
          date_start: null,
          date_end: null,
          updated_at_start: null,
          updated_at_end: null,
          order_id: null,
          sku: null,
          client_names: [],
          orderMethods: [],
          productType: [],
          shipVia: [],
          patient_id: null,
          status: [],
          archived: QUERY_OPERATORS.notEqual,
          componentTypes: [],
          account_uuid: null,
          event_type: null,
          include_test_orders: true,
        },
      }),
    },
  },
  mixins: [ orderHandler ],
  data() {
    return {
      orders: [],
      loadingPage: false,
      itemsPerPage: 10,
      currentPage: 1,
      total: 0,
      translations: translations.orders,
      selectedOrder: null,
    };
  },
  async beforeMount() {
    await this.loadOrdersList();
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      this.loadOrdersList();
    },
    getStatusName(allowedStatus) {
      return allowedStatus.replace('allow_change_status_to_', '');
    },
    buildFilters() {
      const values = [];
      const { data } = this.filters;

      if (this.tagModule !== 'PATIENT_SEARCH') {
        values.push({ field: 'type', value: ORDER_TYPE.FORWARD, operator: QUERY_OPERATORS.equal });
        if (data.archived) {
          values.push({ field: QUERY_FIELD.ORDER_TAG, value: ORDER_TAGS.Archived, operator: data.archived });
        }
      }

      if (this.tagModule === 'PATIENT_SEARCH') {
        values.push({ field: 'patient_id', value: this.tagId, operator: QUERY_OPERATORS.equal });
        return values;
      }
      if ((!this.filters.isValid && !this.tagModule) || !data) {
        return values;
      }

      if (data.order_id) values.push({ field: 'id', value: data.order_id, operator: QUERY_OPERATORS.equal });

      if (data.sku) values.push({ field: 'sku', value: data.sku, operator: QUERY_OPERATORS.like });

      if (data.client_names && data.client_names.length > 0) {
        const selectedClientName = data.client_names.map(item => item.name);
        values.push({ field: 'client_name', value: selectedClientName, operator: QUERY_OPERATORS.in });
      }

      if (data.date_start) {
        values.push({ field: 'created_at', value: data.date_start, operator: QUERY_OPERATORS.greaterThanOrEqualTo });
      }

      if (data.date_end) {
        values.push({ field: 'created_at', value: data.date_end, operator: QUERY_OPERATORS.lessThantOrEqualTo });
      }

      if (data.orderMethods && data.orderMethods.length > 0) {
        const selectedMethods = data.orderMethods.map(item => item.code);
        values.push({ field: 'method', value: selectedMethods, operator: QUERY_OPERATORS.in });
      }

      if (data.patient_id) values.push({ field: 'patient_id', value: data.patient_id, operator: QUERY_OPERATORS.equal });

      if (data.status && data.status.length > 0) {
        const selectedStatus = data.status.map(item => item.code);
        values.push({ field: 'status', value: selectedStatus, operator: QUERY_OPERATORS.in });
      }

      if (data.tags && data.tags.length > 0) {
        const selectedTags = data.tags.map(item => item.code);
        values.push({ field: 'tag', value: selectedTags, operator: QUERY_OPERATORS.in });
      }

      if (data.orderTags && data.orderTags.length > 0) {
        const selectedOrderTags = data.orderTags.map(item => item.value);
        values.push({ field: QUERY_FIELD.ORDER_TAG, value: selectedOrderTags, operator: QUERY_OPERATORS.in });
      }

      if (data.productType && data.productType.length > 0) {
        const selectedProductType = data.productType.map(item => item.value);
        values.push({ field: 'product_type', value: selectedProductType, operator: QUERY_OPERATORS.in });
      }

      if (data.shipVia) {
        values.push({ field: 'ship_via', value: data.shipVia, operator: QUERY_OPERATORS.like });
      }

      if (data.updated_at_start) {
        values.push({ field: 'updated_at', value: data.updated_at_start, operator: QUERY_OPERATORS.greaterThanOrEqualTo });
      }

      if (data.updated_at_end) {
        values.push({ field: 'updated_at', value: data.updated_at_end, operator: QUERY_OPERATORS.lessThantOrEqualTo });
      }

      if (data.componentTypes && data.componentTypes.length > 0) {
        const selectedComponentTypes = data.componentTypes.map(item => item.code);
        values.push({ field: 'component_type', value: selectedComponentTypes, operator: QUERY_OPERATORS.in });
      }

      if (data.account_uuid) values.push({ field: 'account_uuid', value: data.account_uuid, operator: QUERY_OPERATORS.equal });

      if (data.event_type?.length) values.push({ field: 'event_type', value: data.event_type, operator: QUERY_OPERATORS.in });

      if (!data.include_test_orders) {
        values.push({ field: 'client_mode', value: CLIENT_MODE.Test, operator: QUERY_OPERATORS.notEqual });
      }

      return values;
    },
    async loadOrdersList(resetPagination) {
      this.loadingPage = true;
      if (resetPagination) {
        this.currentPage = 1;
      }
      const page = this.currentPage - 1;
      await axios.get(
        'v1/orders',
        {
          params: {
            offset: page * this.itemsPerPage,
            limit: this.itemsPerPage,
            queries: this.buildFilters(),
          },
        },
      ).then(response => {
        this.orders = response.data.orders;
        this.total = response.data.total;
        this.$emit('ordersLoaded', this.total);
      }).catch(err => {
        this.$noty.error('Unable to load orders: ', err);
      }).finally(() => {
        this.loadingPage = false;
      });
    },
    exportOrders() {
      axios({
        url: 'v1/orders/export',
        method: 'GET',
        responseType: 'blob',
        params: {
          queries: this.buildFilters(),
        },
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([ response.data ]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'orders.csv');
          document.body.appendChild(link);
          link.click();
        }).catch(err => {
          console.error(err);
          this.$noty.error('Unable to download orders CSV: ', err.message);
        });
    },
  },
};
</script>

<style lang="scss">
  @import '../../../styles/OrderManagement.scss';
</style>
